import * as types from './mutation-types'
import store from '../..'

export const showToast = async (
  { commit },
  options = { variant: 'info', message: 'TOAST', hideDelay: 3000 }
) => {
  // const toast_types = store.getters['toasts/getToastTypes'] || ''
  return createToast(options).show()
}

export const beginLoading = async () => {  
  const is_loading = store.getters['toasts/getIsLoading'] || false
  if (is_loading) return false
  store.dispatch('toasts/setLoadingStatus', true)  
}

export const endLoading = async () => {  
  const is_loading = store.getters['toasts/getIsLoading'] || false
  if (!is_loading) return false

  store.dispatch('toasts/setLoadingStatus', false) 
}

export const showError = async (message, variant = 'error') => {
  return createToast({
    variant,
    message,
  }).show()
}

function createToast(toast_options) {
  const $toast = store.getters['toasts/getOriginalPlugin'] || {}
  const default_options = {
    variant: 'info',
    message: 'TOAST',
    allowClose: true,
    hideDelay: 5000,
  }
  const options = Object.assign({}, default_options, toast_options)
  let toast = $toast[options.variant](options.message, options)

  toast.hide = function () {
    this.unmount()
  }
  toast.show = function () {
    const toastWrapper = document.createElement('div')
    this.mount(toastWrapper)
    document.body.appendChild(toastWrapper)
    return this
  }
  return toast.show()
}

export const config = async ({ commit }, $toast) => {
  commit(types.SET_ORIGINAL_PLUGIN, { $toast })
}

export const setLoadingMsg = async ({ commit }, message) => {
  commit(types.SET_LOADING_TOAST_MSG, { message })
}

export const setLoadingStatus = async ({ commit }, status) => {
  commit(types.SET_LOADING_STATUS, { status })
}

export const setLoadingToast = async ({ commit }, loading_toast) => {
  commit(types.SET_LOADING_TOAST, { loading_toast })
}
